import { ExtendedTransfer } from "./extendedTransfer";
import { HttpRequest, SDKError, config } from "@smash-sdk/core";
import { errors } from "./errors";
export * from "./errors";
export * from "./types/ListTransfers/ListTransfers";
export * from "./types/ListUserDropboxes/ListUserDropboxes";
export * from "./types/ListUserReceiptFiles/ListUserReceiptFiles";
export * from "./types/ListUserReceipts/ListUserReceipts";
export * from "./types/ListUserTransferEvents/ListUserTransferEvents";
export * from "./types/ListUserTransferFiles/ListUserTransferFiles";
export * from "./types/ListUserTransfers/ListUserTransfers";
export * from "./types/LockTransfer/LockTransfer";
export * from "./types/UpdateDropbox/UpdateDropbox";
export * from "./types/UpdateTeamDropbox/UpdateTeamDropbox";
export * from "./types/UpdateTeamUserDropbox/UpdateTeamUserDropbox";
export * from "./types/UpdateTransfer/UpdateTransfer";
export * from "./types/UpdateTransferCustomization/UpdateTransferCustomization";
export * from "./types/UpdateTransferFile/UpdateTransferFile";
export * from "./types/UpdateTransferFilePart/UpdateTransferFilePart";
export * from "./types/UpdateTransferFileParts/UpdateTransferFileParts";
export * from "./types/UpdateUserDropbox/UpdateUserDropbox";
export * from "./types/CreateDropbox/CreateDropbox";
export * from "./types/CreateDropboxTransfer/CreateDropboxTransfer";
export * from "./types/CreateTeamDropbox/CreateTeamDropbox";
export * from "./types/CreateTeamTransfer/CreateTeamTransfer";
export * from "./types/CreateTeamUserDropbox/CreateTeamUserDropbox";
export * from "./types/CreateTransfer/CreateTransfer";
export * from "./types/CreateTransferFile/CreateTransferFile";
export * from "./types/CreateTransferFilePart/CreateTransferFilePart";
export * from "./types/CreateTransferFileParts/CreateTransferFileParts";
export * from "./types/CreateTransferSignedUrls/CreateTransferSignedUrls";
export * from "./types/CreateUserDropbox/CreateUserDropbox";
export * from "./types/DeleteDropbox/DeleteDropbox";
export * from "./types/DeleteReceipt/DeleteReceipt";
export * from "./types/DeleteReport/DeleteReport";
export * from "./types/DeleteTeamDropbox/DeleteTeamDropbox";
export * from "./types/DeleteTeamReceipt/DeleteTeamReceipt";
export * from "./types/DeleteTeamTransfer/DeleteTeamTransfer";
export * from "./types/DeleteTeamUserDropbox/DeleteTeamUserDropbox";
export * from "./types/DeleteTeamUserReceipt/DeleteTeamUserReceipt";
export * from "./types/DeleteTransfer/DeleteTransfer";
export * from "./types/DeleteTransferFile/DeleteTransferFile";
export * from "./types/DeleteUserDropbox/DeleteUserDropbox";
export * from "./types/DeleteUserReceipt/DeleteUserReceipt";
export * from "./types/DeleteUserTransfer/DeleteUserTransfer";
export * from "./types/GetDropbox/GetDropbox";
export * from "./types/GetDropboxPreview/GetDropboxPreview";
export * from "./types/GetMetricStatistic/GetMetricStatistic";
export * from "./types/GetReceipt/GetReceipt";
export * from "./types/GetReceiptFile/GetReceiptFile";
export * from "./types/GetReport/GetReport";
export * from "./types/GetTeamDropbox/GetTeamDropbox";
export * from "./types/GetTeamMetricStatistic/GetTeamMetricStatistic";
export * from "./types/GetTeamReceipt/GetTeamReceipt";
export * from "./types/GetTeamReceiptFile/GetTeamReceiptFile";
export * from "./types/GetTeamTransfer/GetTeamTransfer";
export * from "./types/GetTeamTransferFile/GetTeamTransferFile";
export * from "./types/GetTeamTransferQueue/GetTeamTransferQueue";
export * from "./types/GetTeamUsage/GetTeamUsage";
export * from "./types/GetTeamUserDropbox/GetTeamUserDropbox";
export * from "./types/GetTeamUserMetricStatistic/GetTeamUserMetricStatistic";
export * from "./types/GetTeamUserReceipt/GetTeamUserReceipt";
export * from "./types/GetTeamUserReceiptFile/GetTeamUserReceiptFile";
export * from "./types/GetTeamUserTransfer/GetTeamUserTransfer";
export * from "./types/GetTeamUserUsage/GetTeamUserUsage";
export * from "./types/GetTransfer/GetTransfer";
export * from "./types/GetTransferFile/GetTransferFile";
export * from "./types/GetTransferFilePreview/GetTransferFilePreview";
export * from "./types/GetTransferPreview/GetTransferPreview";
export * from "./types/GetTransferQueue/GetTransferQueue";
export * from "./types/GetUsage/GetUsage";
export * from "./types/GetUserDropbox/GetUserDropbox";
export * from "./types/GetUserMetricStatistic/GetUserMetricStatistic";
export * from "./types/GetUserReceipt/GetUserReceipt";
export * from "./types/GetUserReceiptFile/GetUserReceiptFile";
export * from "./types/GetUserTransfer/GetUserTransfer";
export * from "./types/GetUserTransferFile/GetUserTransferFile";
export * from "./types/GetUserUsage/GetUserUsage";
export * from "./types/ListDropboxes/ListDropboxes";
export * from "./types/ListReceiptFiles/ListReceiptFiles";
export * from "./types/ListReceipts/ListReceipts";
export * from "./types/ListTeamDropboxes/ListTeamDropboxes";
export * from "./types/ListTeamReceiptFiles/ListTeamReceiptFiles";
export * from "./types/ListTeamReceipts/ListTeamReceipts";
export * from "./types/ListTeamTransferEvents/ListTeamTransferEvents";
export * from "./types/ListTeamTransferFiles/ListTeamTransferFiles";
export * from "./types/ListTeamTransfers/ListTeamTransfers";
export * from "./types/ListTeamUserDropboxes/ListTeamUserDropboxes";
export * from "./types/ListTeamUserReceiptFiles/ListTeamUserReceiptFiles";
export * from "./types/ListTeamUserReceipts/ListTeamUserReceipts";
export * from "./types/ListTeamUserTransfers/ListTeamUserTransfers";
export * from "./types/ListTransferEvents/ListTransferEvents";
export * from "./types/ListTransferFiles/ListTransferFiles";
export * from "./types/ListTransferFilesPreview/ListTransferFilesPreview";
export * from "./types/Download/Download";
export * from "./types/UploadTransferFilePart/UploadTransferFilePart";
const endpoints = {
    "ca-central-1": "https://transfer.ca-central-1.fromsmash.co",
    "eu-central-1": "https://transfer.eu-central-1.fromsmash.co",
    "eu-west-1": "https://transfer.eu-west-1.fromsmash.co",
    "eu-west-2": "https://transfer.eu-west-2.fromsmash.co",
    "eu-west-3": "https://transfer.eu-west-3.fromsmash.co",
    "us-east-1": "https://transfer.us-east-1.fromsmash.co",
    "us-east-2": "https://transfer.us-east-2.fromsmash.co",
    "us-west-1": "https://transfer.us-west-1.fromsmash.co",
    "us-west-2": "https://transfer.us-west-2.fromsmash.co",
};
config.setHosts("transfer", endpoints, false);
export class Transfer extends ExtendedTransfer {
    constructor(params = {}) {
        super({ service: "transfer", ...params, type: "regional", userAgent: "@smash-sdk/transfer@1.0.0-alpha.1" });
        this.errors = errors;
    }
    listTransfers(params = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/transfers",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        limit: params["limit"],
                        start: params["start"],
                        sort: params["sort"],
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListTransfersError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listUserDropboxes(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/user/:userId/dropboxes",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        limit: params["limit"],
                        start: params["start"],
                        sort: params["sort"],
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListUserDropboxesError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listUserReceiptFiles(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/user/:userId/receipt/:receiptId/files",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                        receiptId: params["receiptId"],
                    },
                    queryParameters: {
                        limit: params["limit"],
                        start: params["start"],
                        sort: params["sort"],
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListUserReceiptFilesError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listUserReceipts(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/user/:userId/receipts",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        limit: params["limit"],
                        start: params["start"],
                        sort: params["sort"],
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListUserReceiptsError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listUserTransferEvents(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/user/:userId/transfer/:transferId/events",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                        transferId: params["transferId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListUserTransferEventsError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listUserTransferFiles(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/user/:userId/transfer/:transferId/files",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                        transferId: params["transferId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListUserTransferFilesError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listUserTransfers(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/user/:userId/transfers",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        limit: params["limit"],
                        start: params["start"],
                        sort: params["sort"],
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListUserTransfersError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    lockTransfer(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/transfer/:transferId/lock",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        transferId: params["transferId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.LockTransferError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    updateDropbox(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/dropbox/:dropboxId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        dropboxId: params["dropboxId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    bodyParameters: {
                        name: params["name"],
                        password: params["password"],
                        availabilityDuration: params["availabilityDuration"],
                        maxTransferCount: params["maxTransferCount"],
                        maxBytesUploaded: params["maxBytesUploaded"],
                        customization: params["customization"],
                        configuration: params["configuration"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateDropboxError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    updateTeamDropbox(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/team/:teamId/dropbox/:dropboxId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        dropboxId: params["dropboxId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    bodyParameters: {
                        name: params["name"],
                        password: params["password"],
                        availabilityDuration: params["availabilityDuration"],
                        maxTransferCount: params["maxTransferCount"],
                        maxBytesUploaded: params["maxBytesUploaded"],
                        customization: params["customization"],
                        configuration: params["configuration"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateTeamDropboxError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    updateTeamUserDropbox(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/team/:teamId/user/:userId/dropbox/:dropboxId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        userId: params["userId"],
                        dropboxId: params["dropboxId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    bodyParameters: {
                        name: params["name"],
                        password: params["password"],
                        availabilityDuration: params["availabilityDuration"],
                        maxTransferCount: params["maxTransferCount"],
                        maxBytesUploaded: params["maxBytesUploaded"],
                        customization: params["customization"],
                        configuration: params["configuration"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateTeamUserDropboxError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    updateTransfer(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/transfer/:transferId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        transferId: params["transferId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    bodyParameters: {
                        size: params["size"],
                        filesNumber: params["filesNumber"],
                        language: params["language"],
                        availabilityDuration: params["availabilityDuration"],
                        title: params["title"],
                        delivery: params["delivery"],
                        customization: params["customization"],
                        promotion: params["promotion"],
                        preview: params["preview"],
                        password: params["password"],
                        notification: params["notification"],
                        description: params["description"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateTransferError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    updateTransferCustomization(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/transfer/:transferId/customization",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        transferId: params["transferId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    bodyParameters: {
                        customization: params["customization"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateTransferCustomizationError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    updateTransferFile(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/transfer/:transferId/file/:fileId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        transferId: params["transferId"],
                        fileId: params["fileId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    bodyParameters: {
                        parts: params["parts"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateTransferFileError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    updateTransferFilePart(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/transfer/:transferId/file/:fileId/part/:partId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        transferId: params["transferId"],
                        fileId: params["fileId"],
                        partId: params["partId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    bodyParameters: {
                        etag: params["etag"],
                        crc32: params["crc32"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateTransferFilePartError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    updateTransferFileParts(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/transfer/:transferId/file/:fileId/parts",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        transferId: params["transferId"],
                        fileId: params["fileId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    bodyParameters: {
                        parts: params["parts"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateTransferFilePartsError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    updateUserDropbox(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/user/:userId/dropbox/:dropboxId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                        dropboxId: params["dropboxId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    bodyParameters: {
                        name: params["name"],
                        password: params["password"],
                        availabilityDuration: params["availabilityDuration"],
                        maxTransferCount: params["maxTransferCount"],
                        maxBytesUploaded: params["maxBytesUploaded"],
                        customization: params["customization"],
                        configuration: params["configuration"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateUserDropboxError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    createDropbox(params = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/dropbox",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "01-2024",
                    },
                    bodyParameters: {
                        name: params["name"],
                        password: params["password"],
                        availabilityDuration: params["availabilityDuration"],
                        maxTransferCount: params["maxTransferCount"],
                        maxBytesUploaded: params["maxBytesUploaded"],
                        customization: params["customization"],
                        configuration: params["configuration"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateDropboxError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    createDropboxTransfer(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/dropbox/:dropboxId/transfer",
                    headers: {
                        Authorization: "Bearer " + this.token,
                        "smash-authorization": params["smash-authorization"],
                    },
                    pathParameters: {
                        dropboxId: params["dropboxId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    bodyParameters: {
                        size: params["size"],
                        filesNumber: params["filesNumber"],
                        domain: params["domain"],
                        customUrl: params["customUrl"],
                        language: params["language"],
                        availabilityDuration: params["availabilityDuration"],
                        title: params["title"],
                        customization: params["customization"],
                        promotion: params["promotion"],
                        delivery: params["delivery"],
                        preview: params["preview"],
                        accessTracking: params["accessTracking"],
                        password: params["password"],
                        notification: params["notification"],
                        description: params["description"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateDropboxTransferError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    createTeamDropbox(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/team/:teamId/dropbox",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    bodyParameters: {
                        name: params["name"],
                        password: params["password"],
                        availabilityDuration: params["availabilityDuration"],
                        maxTransferCount: params["maxTransferCount"],
                        maxBytesUploaded: params["maxBytesUploaded"],
                        customization: params["customization"],
                        configuration: params["configuration"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateTeamDropboxError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    createTeamTransfer(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/team/:teamId/transfer",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    bodyParameters: {
                        size: params["size"],
                        filesNumber: params["filesNumber"],
                        domain: params["domain"],
                        customUrl: params["customUrl"],
                        language: params["language"],
                        availabilityDuration: params["availabilityDuration"],
                        title: params["title"],
                        delivery: params["delivery"],
                        customization: params["customization"],
                        promotion: params["promotion"],
                        preview: params["preview"],
                        accessTracking: params["accessTracking"],
                        password: params["password"],
                        notification: params["notification"],
                        description: params["description"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateTeamTransferError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    createTeamUserDropbox(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/team/:teamId/user/:userId/dropbox",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    bodyParameters: {
                        name: params["name"],
                        password: params["password"],
                        availabilityDuration: params["availabilityDuration"],
                        maxTransferCount: params["maxTransferCount"],
                        maxBytesUploaded: params["maxBytesUploaded"],
                        customization: params["customization"],
                        configuration: params["configuration"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateTeamUserDropboxError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    createTransfer(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/transfer",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "01-2024",
                    },
                    bodyParameters: {
                        size: params["size"],
                        filesNumber: params["filesNumber"],
                        domain: params["domain"],
                        customUrl: params["customUrl"],
                        language: params["language"],
                        availabilityDuration: params["availabilityDuration"],
                        title: params["title"],
                        delivery: params["delivery"],
                        customization: params["customization"],
                        promotion: params["promotion"],
                        preview: params["preview"],
                        accessTracking: params["accessTracking"],
                        password: params["password"],
                        notification: params["notification"],
                        description: params["description"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateTransferError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    createTransferFile(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/transfer/:transferId/file",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        transferId: params["transferId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    bodyParameters: {
                        name: params["name"],
                        size: params["size"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateTransferFileError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    createTransferFilePart(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/transfer/:transferId/file/:fileId/part",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        transferId: params["transferId"],
                        fileId: params["fileId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    bodyParameters: {
                        id: params["id"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateTransferFilePartError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    createTransferFileParts(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/transfer/:transferId/file/:fileId/parts",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        transferId: params["transferId"],
                        fileId: params["fileId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    bodyParameters: {
                        parts: params["parts"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateTransferFilePartsError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    createTransferSignedUrls(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/transfer/:transferId/urls",
                    headers: {
                        Authorization: "Bearer " + this.token,
                        "smash-authorization": params["smash-authorization"],
                    },
                    pathParameters: {
                        transferId: params["transferId"],
                    },
                    queryParameters: {
                        e: params["e"],
                        version: "01-2024",
                    },
                    bodyParameters: {
                        files: params["files"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateTransferSignedUrlsError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    createUserDropbox(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/user/:userId/dropbox",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    bodyParameters: {
                        name: params["name"],
                        password: params["password"],
                        availabilityDuration: params["availabilityDuration"],
                        maxTransferCount: params["maxTransferCount"],
                        maxBytesUploaded: params["maxBytesUploaded"],
                        customization: params["customization"],
                        configuration: params["configuration"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateUserDropboxError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    deleteDropbox(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/dropbox/:dropboxId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        dropboxId: params["dropboxId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteDropboxError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    deleteReceipt(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/receipt/:receiptId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        receiptId: params["receiptId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteReceiptError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    deleteReport(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/report/:reportId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        reportId: params["reportId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteReportError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    deleteTeamDropbox(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/team/:teamId/dropbox/:dropboxId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        dropboxId: params["dropboxId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteTeamDropboxError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    deleteTeamReceipt(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/team/:teamId/receipt/:receiptId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        receiptId: params["receiptId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteTeamReceiptError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    deleteTeamTransfer(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/team/:teamId/transfer/:transferId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        transferId: params["transferId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteTeamTransferError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    deleteTeamUserDropbox(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/team/:teamId/user/:userId/dropbox/:dropboxId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        userId: params["userId"],
                        dropboxId: params["dropboxId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteTeamUserDropboxError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    deleteTeamUserReceipt(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/team/:teamId/user/:userId/receipt/:receiptId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        userId: params["userId"],
                        receiptId: params["receiptId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteTeamUserReceiptError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    deleteTransfer(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/transfer/:transferId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        transferId: params["transferId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteTransferError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    deleteTransferFile(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/transfer/:transferId/file/:fileId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        transferId: params["transferId"],
                        fileId: params["fileId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteTransferFileError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    deleteUserDropbox(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/user/:userId/dropbox/:dropboxId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                        dropboxId: params["dropboxId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteUserDropboxError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    deleteUserReceipt(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/user/:userId/receipt/:receiptId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                        receiptId: params["receiptId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteUserReceiptError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    deleteUserTransfer(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/user/:userId/transfer/:transferId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                        transferId: params["transferId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteUserTransferError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getDropbox(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/dropbox/:dropboxId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        dropboxId: params["dropboxId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetDropboxError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getDropboxPreview(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/dropbox/:dropboxId/preview",
                    headers: {
                        Authorization: "Bearer " + this.token,
                        "smash-authorization": params["smash-authorization"],
                    },
                    pathParameters: {
                        dropboxId: params["dropboxId"],
                    },
                    queryParameters: {
                        e: params["e"],
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetDropboxPreviewError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getMetricStatistic(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/metric/:metricName/statistic/:statisticName",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        metricName: params["metricName"],
                        statisticName: params["statisticName"],
                    },
                    queryParameters: {
                        startDate: params["startDate"],
                        endDate: params["endDate"],
                        unit: params["unit"],
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetMetricStatisticError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getReceipt(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/receipt/:receiptId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        receiptId: params["receiptId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetReceiptError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getReceiptFile(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/receipt/:receiptId/file/:fileId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        receiptId: params["receiptId"],
                        fileId: params["fileId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetReceiptFileError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getReport(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/report/:reportId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        reportId: params["reportId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetReportError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getTeamDropbox(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/dropbox/:dropboxId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        dropboxId: params["dropboxId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetTeamDropboxError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getTeamMetricStatistic(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/metric/:metricName/statistic/:statisticName",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        metricName: params["metricName"],
                        statisticName: params["statisticName"],
                    },
                    queryParameters: {
                        startDate: params["startDate"],
                        endDate: params["endDate"],
                        unit: params["unit"],
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetTeamMetricStatisticError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getTeamReceipt(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/receipt/:receiptId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        receiptId: params["receiptId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetTeamReceiptError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getTeamReceiptFile(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/receipt/:receiptId/file/:fileId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        receiptId: params["receiptId"],
                        fileId: params["fileId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetTeamReceiptFileError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getTeamTransfer(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/transfer/:transferId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        transferId: params["transferId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetTeamTransferError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getTeamTransferFile(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/transfer/:transferId/file/:fileId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        transferId: params["transferId"],
                        fileId: params["fileId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetTeamTransferFileError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getTeamTransferQueue(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/transfer/queue",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                    },
                    queryParameters: {
                        size: params["size"],
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetTeamTransferQueueError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getTeamUsage(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/usage",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetTeamUsageError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getTeamUserDropbox(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/user/:userId/dropbox/:dropboxId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        userId: params["userId"],
                        dropboxId: params["dropboxId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetTeamUserDropboxError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getTeamUserMetricStatistic(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/user/:userId/metric/:metricName/statistic/:statisticName",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        userId: params["userId"],
                        metricName: params["metricName"],
                        statisticName: params["statisticName"],
                    },
                    queryParameters: {
                        startDate: params["startDate"],
                        endDate: params["endDate"],
                        unit: params["unit"],
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetTeamUserMetricStatisticError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getTeamUserReceipt(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/user/:userId/receipt/:receiptId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        userId: params["userId"],
                        receiptId: params["receiptId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetTeamUserReceiptError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getTeamUserReceiptFile(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/user/:userId/receipt/:receiptId/file/:fileId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        userId: params["userId"],
                        receiptId: params["receiptId"],
                        fileId: params["fileId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetTeamUserReceiptFileError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getTeamUserTransfer(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/user/:userId/transfer/:transferId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        userId: params["userId"],
                        transferId: params["transferId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetTeamUserTransferError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getTeamUserUsage(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/user/:userId/usage",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetTeamUserUsageError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getTransfer(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/transfer/:transferId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        transferId: params["transferId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetTransferError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getTransferFile(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/transfer/:transferId/file/:fileId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        transferId: params["transferId"],
                        fileId: params["fileId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetTransferFileError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getTransferFilePreview(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/transfer/:transferId/file/:fileId/preview",
                    headers: {
                        Authorization: "Bearer " + this.token,
                        "smash-authorization": params["smash-authorization"],
                    },
                    pathParameters: {
                        transferId: params["transferId"],
                        fileId: params["fileId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetTransferFilePreviewError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getTransferPreview(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/transfer/:transferId/preview",
                    headers: {
                        Authorization: "Bearer " + this.token,
                        "smash-authorization": params["smash-authorization"],
                    },
                    pathParameters: {
                        transferId: params["transferId"],
                    },
                    queryParameters: {
                        e: params["e"],
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetTransferPreviewError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getTransferQueue(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/transfer/queue",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        size: params["size"],
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetTransferQueueError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getUsage() {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/usage",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetUsageError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getUserDropbox(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/user/:userId/dropbox/:dropboxId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                        dropboxId: params["dropboxId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetUserDropboxError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getUserMetricStatistic(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/user/:userId/metric/:metricName/statistic/:statisticName",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                        metricName: params["metricName"],
                        statisticName: params["statisticName"],
                    },
                    queryParameters: {
                        startDate: params["startDate"],
                        endDate: params["endDate"],
                        unit: params["unit"],
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetUserMetricStatisticError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getUserReceipt(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/user/:userId/receipt/:receiptId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                        receiptId: params["receiptId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetUserReceiptError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getUserReceiptFile(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/user/:userId/receipt/:receiptId/file/:fileId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                        receiptId: params["receiptId"],
                        fileId: params["fileId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetUserReceiptFileError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getUserTransfer(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/user/:userId/transfer/:transferId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                        transferId: params["transferId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetUserTransferError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getUserTransferFile(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/user/:userId/transfer/:transferId/file/:fileId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                        transferId: params["transferId"],
                        fileId: params["fileId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetUserTransferFileError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getUserUsage(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/user/:userId/usage",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetUserUsageError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listDropboxes(params = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/dropboxes",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        limit: params["limit"],
                        start: params["start"],
                        sort: params["sort"],
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListDropboxesError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listReceiptFiles(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/receipt/:receiptId/files",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        receiptId: params["receiptId"],
                    },
                    queryParameters: {
                        limit: params["limit"],
                        start: params["start"],
                        sort: params["sort"],
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListReceiptFilesError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listReceipts(params = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/receipts",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        limit: params["limit"],
                        start: params["start"],
                        sort: params["sort"],
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListReceiptsError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listTeamDropboxes(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/dropboxes",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                    },
                    queryParameters: {
                        limit: params["limit"],
                        start: params["start"],
                        sort: params["sort"],
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListTeamDropboxesError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listTeamReceiptFiles(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/receipt/:receiptId/files",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        receiptId: params["receiptId"],
                    },
                    queryParameters: {
                        limit: params["limit"],
                        start: params["start"],
                        sort: params["sort"],
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListTeamReceiptFilesError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listTeamReceipts(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/receipts",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                    },
                    queryParameters: {
                        limit: params["limit"],
                        start: params["start"],
                        sort: params["sort"],
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListTeamReceiptsError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listTeamTransferEvents(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/transfer/:transferId/events",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        transferId: params["transferId"],
                        teamId: params["teamId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListTeamTransferEventsError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listTeamTransferFiles(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/transfer/:transferId/files",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        transferId: params["transferId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListTeamTransferFilesError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listTeamTransfers(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/transfers",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                    },
                    queryParameters: {
                        limit: params["limit"],
                        start: params["start"],
                        sort: params["sort"],
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListTeamTransfersError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listTeamUserDropboxes(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/user/:userId/dropboxes",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        userId: params["userId"],
                    },
                    queryParameters: {
                        limit: params["limit"],
                        start: params["start"],
                        sort: params["sort"],
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListTeamUserDropboxesError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listTeamUserReceiptFiles(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/user/:userId/receipt/:receiptId/files",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        userId: params["userId"],
                        receiptId: params["receiptId"],
                    },
                    queryParameters: {
                        limit: params["limit"],
                        start: params["start"],
                        sort: params["sort"],
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListTeamUserReceiptFilesError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listTeamUserReceipts(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/user/:userId/receipts",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        userId: params["userId"],
                    },
                    queryParameters: {
                        limit: params["limit"],
                        start: params["start"],
                        sort: params["sort"],
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListTeamUserReceiptsError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listTeamUserTransfers(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/user/:userId/transfers",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        userId: params["userId"],
                    },
                    queryParameters: {
                        limit: params["limit"],
                        start: params["start"],
                        sort: params["sort"],
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListTeamUserTransfersError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listTransferEvents(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/transfer/:transferId/events",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        transferId: params["transferId"],
                    },
                    queryParameters: {
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListTransferEventsError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listTransferFiles(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/transfer/:transferId/files",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        transferId: params["transferId"],
                    },
                    queryParameters: {
                        limit: params["limit"],
                        start: params["start"],
                        sort: params["sort"],
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListTransferFilesError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listTransferFilesPreview(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/transfer/:transferId/files/preview",
                    headers: {
                        Authorization: "Bearer " + this.token,
                        "smash-authorization": params["smash-authorization"],
                    },
                    pathParameters: {
                        transferId: params["transferId"],
                    },
                    queryParameters: {
                        limit: params["limit"],
                        start: params["start"],
                        sort: params["sort"],
                        version: "01-2024",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListTransferFilesPreviewError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
}
Transfer.errors = errors;
